import React from 'react';


export default function Workshops() {
    return (
        <div><h1>Sin novedades futuras.</h1></div>
    )
}